import { Region } from '@lemon8/webapp-shared/i18n';
import { Comment } from 'schema-dts';
import { TComment } from 'shared/models';

export const CommentJsonLDUtil = {
  getCommentsJsonLd: (props: { comments: TComment[]; region: Region }): Comment[] => {
    const { comments, region } = props;

    return comments.map((item: TComment) => {
      return {
        '@type': 'Comment',
        text: item.text.replace(/\s/g, ' ') || '',
        author: {
          '@type': 'Person',
          name: item.author.nickName,
          alternateName: item.author.linkName,
          image: item.author.avatar,
          identifier: {
            '@type': 'PropertyValue',
            propertyID: 'Username',
            value: item.author.linkName,
          },
          mainEntityOfPage: {
            '@type': 'ProfilePage',
            '@id': `https://www.lemon8-app.com/${item.author.linkName}?region=${region}`,
          },
        },
      };
    });
  },
};
